export default __webpack_public_path__ + "static/media/laserpega.d6883efb.png";